import React, { FC } from 'react';
import { Box, Stack } from '@mui/material';
import { Icon } from '@iconify/react';
import { useSelector } from 'react-redux';
import { GLOBAL_USER } from '../../utils/constants';
import { RootState } from '../../redux/store';
import { updateOrder, OrderUpdate } from '../../services/order';
import useSnackbarNotifications from '../../hooks/useSnackbarNotifications';
import Button from '../../components/Button/Button';
import { Typography } from '../../components';

type Props = {
  transactionErrors: any;
  setRetryDecisionPending?: any;
  setTransactionErrors?: any;
};

const errorBox = (errorType: string, errorMsg: string) => {
  return (
    <Box sx={{ display: 'flex' }}>
      <Box>
        <Icon icon="ri:information-line" color="#E04732" width="16px" height="16px" style={{ paddingTop: '2px' }} />
      </Box>
      <Typography weight={400} size={12} color="#E04732" marginLeft={1} lineHeight={1.7}>
        {errorType}: {errorMsg}
      </Typography>
    </Box>
  );
};

const successBox = (successType: string, successMsg: string) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Icon icon="mdi:check-circle-outline" width="16px" height="16px" color="#1B1B1B" />
      <Typography weight={400} size={12} color="#1B1B1B" marginLeft={1} lineHeight={1.7}>
        {successType}: {successMsg}
      </Typography>
    </Box>
  );
};

const ReleaseAlert: FC<Props> = ({ transactionErrors, setRetryDecisionPending, setTransactionErrors }) => {
  const { sfdcResponse, vmsResponse } = transactionErrors;

  const vehicle = useSelector((state: RootState) => state.vehicle.data);
  const { showSuccessSnackbar, showErrorSnackbar } = useSnackbarNotifications();

  const retryReleaseToInventory = async () => {
    const data = {
      actionType: 'RELEASE',
      orderNumber: vehicle?.orderId,
      vin: vehicle.VIN,
      requestor: GLOBAL_USER,
      retry: true,
    };
    setTransactionErrors(false);
    setRetryDecisionPending(true);
    const res = await updateOrder(data as OrderUpdate);
    if (res.message === 'Success') {
      showSuccessSnackbar({ message: 'Success' });
    } else if (res?.sdfcResponse?.data || res?.vmsResponse?.data) {
      console.log(res);
      setTransactionErrors(res);
    } else {
      showErrorSnackbar({ message: res.message });
    }
    setRetryDecisionPending(false);
  };

  return (
    <Stack direction="row" alignItems="center" justifyContent="flex-end" gap={1}>
      <Box
        width="100%"
        sx={{
          border: 1,
          borderRadius: '4px',
          borderColor: '#E04732',
          padding: '7px 10px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: '20px',
          bgcolor: '#FFDBD7',
        }}
      >
        <Box>
          {sfdcResponse?.statusCode !== 200
            ? errorBox('Salesforce', sfdcResponse?.data)
            : successBox('Salesforce', sfdcResponse?.data)}
          {vmsResponse?.statusCode !== 200 ? errorBox('SAP', vmsResponse?.data) : successBox('SAP', vmsResponse?.data)}
        </Box>
        <Box>
          <Button
            size="small"
            onClick={() => retryReleaseToInventory()}
            color="error"
            sx={{
              border: 1,
              borderRadius: '4px',
              borderColor: '#E04732',
              fontSize: '12px',
              fontWeight: '400px',
              textTransform: 'capitalize',
              lineHeight: '15.6px',
              padding: '7px 10px',
              bgcolor: 'white',
            }}
          >
            Retry
          </Button>
        </Box>
      </Box>
    </Stack>
  );
};

export default ReleaseAlert;
